import { Icon } from "@iconify/react/dist/iconify.js";

const OrdersFilters = ({
    animationStates,
    activeFilters,
    activeFilter,
    showStatusDropdown,
    setShowStatusDropdown,
    handleFilterClick,
    handleStatusSelect,
    resetFilters,
    isAnyFilterActive,
    totalFilteredOrders,
    showMobileFilters,
    setShowMobileFilters,
    getAvailableStatusTypes
}) => {
    // Filter configuration
    const filterConfig = [
        {
            id: 'bookingTime',
            label: 'Booking Time',
            icon: 'stash:data-date'
        },
        {
            id: 'orderStatus',
            label: 'Order Status',
            icon: 'material-symbols:order-approve-outline'
        },
        {
            id: 'multipleEquipment',
            label: 'Multiple Equipment',
            icon: 'material-symbols:construction'
        }
    ];

    // Filter Button Component
    const FilterButton = ({ id, label, icon }) => {
        if (id === 'orderStatus') {
            return (
                <div className="relative">
                    <button
                        onClick={() => handleFilterClick(id)}
                        className={`flex flex-row items-center gap-2 justify-between p-2 ${activeFilter === id ? 'bg-primary-20 border-primary-30 border' : 'bg-bgSecondary md:button-container'} w-full md:w-fit rounded-md text-sm`}
                    >
                        <div className="flex flex-row items-center gap-1">
                            <Icon icon={icon} className={`text-xl ${activeFilter === id ? 'text-primary' : 'text-accent'}`} />
                            {activeFilter === id && activeFilters.orderStatus ? activeFilters.orderStatus : label}
                        </div>
                        <Icon
                            icon={showStatusDropdown ? 'material-symbols:keyboard-arrow-up' : 'material-symbols:keyboard-arrow-down'}
                            className={`text-xl ${activeFilter === id ? 'text-primary' : 'text-accent'}`}
                        />
                    </button>

                    {/* Status Dropdown */}
                    {showStatusDropdown && (
                        <div className="absolute top-full left-0 mt-2 bg-bgSecondary card-container rounded-lg border border-bgAccent z-50 min-w-[200px]">
                            <div className="flex flex-col">
                                {getAvailableStatusTypes().map(status => (
                                    <button
                                        key={status}
                                        onClick={() => handleStatusSelect(status)}
                                        className={`text-left p-2 rounded transition-colors text-sm ${
                                            activeFilters.orderStatus === status ? 'bg-primary-20 border-primary-30 border' : 'bg-bgSecondary'
                                        }`}
                                    >
                                        {status}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Click outside to close dropdown */}
                    {showStatusDropdown && (
                        <div
                            className="fixed inset-0 z-40"
                            onClick={() => setShowStatusDropdown(false)}
                        />
                    )}
                </div>
            );
        }

        return (
            <button
                onClick={() => handleFilterClick(id)}
                className={`flex flex-row items-center gap-2 justify-between p-2 ${activeFilter === id ? 'bg-primary-20 border-primary-30 border' : 'bg-bgSecondary md:button-container'} w-full md:w-fit rounded-md text-sm`}
            >
                <div className="flex flex-row items-center gap-1">
                    <Icon icon={icon} className={`text-xl ${activeFilter === id ? 'text-primary' : 'text-accent'}`} />
                    {label}
                </div>
                {activeFilter === id && id === 'bookingTime' && (
                    <Icon
                        icon={activeFilters[id] === 'asc' ? 'material-symbols:arrow-upward' : 'material-symbols:arrow-downward'}
                        className="text-xl text-primary"
                    />
                )}
                {activeFilter === id && id === 'multipleEquipment' && (
                    <Icon
                        icon={activeFilters.multipleEquipment === true ? 'material-symbols:check' : 'material-symbols:close'}
                        className="text-xl text-primary"
                    />
                )}
            </button>
        );
    };

    return (
        <div className={`w-full flex-shrink-0 transition-all duration-500 ease-out z-10 ${
            animationStates.filters
                ? 'opacity-100 translate-y-0'
                : 'opacity-0 translate-y-4'
        }`}>
            <div className="w-full flex flex-row items-start sm:items-center justify-between gap-2">
                {/* Desktop Filters (xl and above) */}
                <div className="flex-row gap-2 items-center hidden xl:flex">
                    {filterConfig.map(filter => (
                        <FilterButton
                            key={filter.id}
                            id={filter.id}
                            label={filter.label}
                            icon={filter.icon}
                        />
                    ))}
                    <div className="flex items-center gap-1 text-sm text-font-secondary whitespace-nowrap">
                        <Icon icon="material-symbols:info-outline" className="text-lg" />
                        <span><b className="text-primary">{totalFilteredOrders}</b> orders found</span>
                    </div>
                    {isAnyFilterActive && (
                        <button
                            onClick={resetFilters}
                            className="flex flex-row items-center gap-2 p-2 button-container whitespace-nowrap text-sm ml-auto rounded-md transition-colors"
                        >
                            <Icon icon="material-symbols:refresh" className="text-xl text-accent" />
                            Reset Filters
                        </button>
                    )}
                </div>

                {/* Mobile All Filters Button (below xl) */}
                <div className="w-fit relative xl:hidden">
                    <button
                        onClick={() => setShowMobileFilters(!showMobileFilters)}
                        className="flex flex-row items-center gap-2 p-2 button-container text-sm rounded-md transition-colors w-full justify-center"
                    >
                        <Icon icon="material-symbols:filter-list" className="text-xl text-accent" />
                        All Filters
                        {isAnyFilterActive && (
                            <span className="bg-primary text-white text-xs px-2 py-1 rounded-full ml-2">
                                {Object.values(activeFilters).filter(Boolean).length}
                            </span>
                        )}
                    </button>

                    {/* Mobile Filters Dropdown */}
                    {showMobileFilters && (
                        <div className="absolute top-full w-fit left-0 right-0 mt-2 button-container rounded-md shadow-lg border border-bgAccent z-50">
                            <div className="flex flex-col ">
                                {filterConfig.map(filter => (
                                    <FilterButton
                                        key={filter.id}
                                        id={filter.id}
                                        label={filter.label}
                                        icon={filter.icon}
                                    />
                                ))}
                                {isAnyFilterActive && (
                                    <button
                                        onClick={() => {
                                            resetFilters();
                                            setShowMobileFilters(false);
                                        }}
                                        className="flex flex-row items-center gap-2 p-2 text-sm rounded-md transition-colors justify-center mt-2 border-t border-border"
                                    >
                                        <Icon icon="material-symbols:refresh" className="text-xl text-error" />
                                        Reset Filters
                                    </button>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Click outside to close mobile filters */}
                    {showMobileFilters && (
                        <div
                            className="fixed inset-0 z-40"
                            onClick={() => setShowMobileFilters(false)}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default OrdersFilters;
